export enum SphereTrajectoryOption {
  Linear = 0,
  Ellipse = 1,
  Bouncing = 2,
  Snapout = 3,
  Horizontal8 = 4,
}
